import React, { Component } from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import { connect } from 'react-redux'; // to connect to redux store from containers redux.js or any other redux store
import Input from 'react-toolbox/lib/input';// to use input from react-toolbox library
import renderIf from 'render-if';// to use conditional rendering based oemailErrorMessagen values that is provided to component
import Error from 'components/ErrorMessage';// to display error messages on invalid user input
import FullScreenLoader from 'components/FullScreenLoader';// to show loder on screen whenever there is a api call or operations in component
import Autocomplete from 'react-autocomplete';
import AutocompleteToolbox from 'react-toolbox/lib/autocomplete';
import { regExForName } from 'constants/Regularexpression'; // regular expressions to validate user input
import CustomButton from 'components/CustomButton';
import { push } from 'react-router-redux';
import { Map, is } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import { selector } from './redux';
import { saveCoachProfile, getCoachProfile, searchSchools, getCoachFromDatabase } from './actions';
import styles from './CoachRegistration.scss';// to import local scss fle

const Allstate = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District Of Columbia',
  FM: 'Federated States Of Micronesia',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
};


class CoachRegistrationModal extends Component {

  static propTypes ={
    saveCoachProfile: PropTypes.func,
    attributes: PropTypes.shape(),
    validateCoachRequested: PropTypes.bool.isRequired, // eslint-disable-line
    schools: PropTypes.shape(),
    searchSchools: PropTypes.func,
    coachRegistered: PropTypes.bool,
    history: PropTypes.func.isRequired,
    usedFor: PropTypes.string,
    getDataForCoach: PropTypes.func.isRequired,
    getCoachFromDatabase: PropTypes.func.isRequired,
    validCoachData: PropTypes.func.isRequired,
    adminStyles: PropTypes.string,
    writeCollegeName: PropTypes.func,
  };

  static defaultProps = {
    saved: false,
    saveCoachProfile: () => {},
    coachRegistered: false,
    router: {
      push: () => {},
    },
    history: {},
    profile: Map(),
    attributes: {},
    user: {},
    getCoachProfile: () => {},
    schools: { school: 'enter school name' },
    searchSchools: () => {},
    usedFor: '',
    adminStyles: '',
    getScholsName: () => {},
    writeCollegeName: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      fullname: '',
      collegeName: '',
      school: '',
      schoolNames: [],
      states: '',
      city: '',
      division: '',
      sport: 'FOOTBALL',
      validHighSchool: false,
      highSchoolErrorMessage: '',
      validState: false,
      stateErrorMessage: '',
      validCity: false,
      cityErrorMessage: '',
      validTeamPageUrl: false,
      teamPageUrlErrorMessage: '',
      schoolOnContact: '',
      validQuestionaire: false,
      questionaireErrorMessage: '',
      startLoader: false,
    };
    this.schoolSearch = this.schoolSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.removeValue = this.removeValue.bind(this);
    this.Map = Map;
    this.is = is;
  }


  componentWillMount() {
    if (this.props.attributes && this.props.attributes.size > 0 &&
      !this.props.validCoachData.size > 0) {
      let payload = {};
      payload = Object.assign({
        coach_email: this.props.attributes.get('email'),
      });
      this.props.getCoachFromDatabase(payload);
    }
    if (this.props.validCoachData.size > 0) {
      let results = this.props.validCoachData.get('hits');
      const totalHits = results.get('hits').size;
      if (totalHits > 0) {
        results = results.get('hits');
        results = results.toJS();
        const firstItemFromElastic = results[0]._source; // eslint-disable-line
        const newState = {
          coachId: firstItemFromElastic.coach_id,
          schoolId: firstItemFromElastic.college_id,
          teamPageUrl: firstItemFromElastic.team_page_link,
          questionLink: firstItemFromElastic.question_link,
          division: firstItemFromElastic.division,
          city: firstItemFromElastic.city,
          name: firstItemFromElastic.name,
          states: firstItemFromElastic.state,
          sport: firstItemFromElastic.sport,
          school: firstItemFromElastic.college,
          coachEmail: firstItemFromElastic.coach_email,
          description: firstItemFromElastic.description,
        };
        this.setState(newState);
      }
    }
  }


  componentWillReceiveProps(nextProps) {
    if (nextProps.coachRegistered && this.props.coachRegistered !== nextProps.coachRegistered
        && is(this.props.schools, nextProps.schools)) {
      this.props.history.push('/view/coach/dashboard');
      debugger;  // eslint-disable-line
    }
    // if ( nextProps.coachRegistered && !nextProps.isLoading ){
    //   this.props.history.push('/view/coach/dashboard');
    // }
    // debugger;  // eslint-disable-line
    if (nextProps.attributes.size > 0 && !nextProps.validCoachData.size > 0
        && !nextProps.validateCoachRequested) {
      let payload = {};
      payload = Object.assign({
        coach_email: nextProps.attributes.get('email'),
      });
      this.props.getCoachFromDatabase(payload);
    } else if (nextProps.validCoachData.size > 0 && is(this.props.schools, nextProps.schools)) {
      let results = nextProps.validCoachData.get('hits');
      const totalHits = results.get('hits').size;
      if (totalHits > 0) {
        results = results.get('hits');
        results = results.toJS();
        const firstItemFromElastic = results[0]._source; // eslint-disable-line
        const newState = {
          coachId: firstItemFromElastic.coach_id,
          schoolId: firstItemFromElastic.college_id,
          teamPageUrl: firstItemFromElastic.team_page_link,
          questionLink: firstItemFromElastic.question_link,
          division: firstItemFromElastic.division,
          city: firstItemFromElastic.city,
          name: firstItemFromElastic.name,
          states: firstItemFromElastic.state,
          sport: firstItemFromElastic.sport,
          school: firstItemFromElastic.college,
          coachEmail: firstItemFromElastic.coach_email,
          description: firstItemFromElastic.description,
        };
        this.setState(newState);
      }
    }
    const { schools = {} } = this.props;
    if (this.Map.isMap(nextProps.schools) && !this.is(nextProps.schools, schools)) {
      const total = nextProps.schools.get('hits').get('total');
      const hits = [];
      if (total > 0) {
        let results = nextProps.schools.get('hits');
        results = results.get('hits');
        results = results.toJS();

        results.forEach((school) => {
          const obj = {};
          const college = school._source.college; // eslint-disable-line
          const collegeId = school._source.id; // eslint-disable-line
          const cityFromCollege = school._source.city; // eslint-disable-line
          const stateFromCollege = school._source.state; // eslint-disable-line
          const question = school._source.football_questionaire_page; // eslint-disable-line
          const teamPage = school._source.football_team_page; // eslint-disable-line
          const twitter = school._source.college_twitter; // eslint-disable-line
          const coachDivision = school._source.division; // eslint-disable-line
          const id = school._source.id; // eslint-disable-line
          const idKey = collegeId; // eslint-disable-line
          const hbcu = school._source.hbcu; // eslint-disable-line
          const minAct = school._source.min_act; // eslint-disable-line
          const minGpa = school._source.min_gpa; // eslint-disable-line
          obj.minGpa = minGpa;
          obj.minAct = minAct;
          obj.hbcu = hbcu;
          obj.value = college;
          obj.key = idKey;
          obj.state = stateFromCollege;
          obj.city = cityFromCollege;
          obj.teamPageUrl = teamPage;
          obj.collegetwitter = twitter;
          obj.questionLink = question;
          obj.division = coachDivision;
          obj.id = id;
          hits.push(obj);
        });
        this.setState({ schoolNames: hits });
      }
    }
  }

  schoolSearch(name, value) {
    if (this.timer) { clearTimeout(this.timer); }

    this.setState({ ...this.state, [name]: value });

    if (value && value.length >= 3) {
      this.timer = setTimeout(() => {
        this.props.searchSchools(value);
      }, 100);
    }
  }

  removeValue(name) {
    this.setState({ ...this.state, [name]: '' });
  }

  handleChange = (name, value) => {
    this.setState({ ...this.state, [name]: value });
  };

  handleOnclick(value) {
    /* validations for field */
    const enteredValue = this.state.school;
    const highSchool = typeof enteredValue === 'string';
    const updated = {};
    if (highSchool && this.state.school !== '') {
      updated.validHighSchool = true;
    } else {
      updated.highSchoolErrorMessage = 'PLease insert a valid school name';
    }
    /* validations for field */

    /* validation for state */
    if (this.state.states === '') {
      updated.stateErrorMessage = 'Please select state.';
    } else {
      updated.validState = true;
    }
    /* validation for state */

    /* validation of city */
    const selectedCity = regExForName.test(this.state.city);
    if (selectedCity && this.state.city !== '') {
      updated.validCity = true;
    } else {
      updated.cityErrorMessage = 'City is not added.';
    }
   /* validation of city */

    /* validation for teamPageUrl */
    // const enteredTeamPageUrl = regExForUrl.test(this.state.teamPageUrl);
    if (this.state.teamPageUrl !== '' && this.state.teamPageUrl !== undefined) {
      updated.validTeamPageUrl = true;
    } else {
      updated.teamPageUrlErrorMessage = 'Please insert a valid url.';
    }
   /* validation for teamPageUrl */

      /* validation for Questionnaire Link */
    // const enteredQuestionaireLink = regExForUrl.test(this.state.questionLink);
    if (this.state.questionLink === '' && this.state.questionLink !== undefined) {
      updated.validQuestionaire = true;
    } else if (this.state.questionLink === 'no page') {
      updated.questionaireErrorMessage = 'Please add a valid questionaire url';
    } else if (this.state.questionLink !== '' && this.state.questionLink !== undefined) {
      updated.validQuestionaire = true;
    } else {
      updated.questionaireErrorMessage = 'Please add a valid questionaire url';
    }
      /* validation for question lin */

    this.setState(updated, () => {
      let payload = {};
      const s = this.state;
          // eslint-disable-next-line
          const profile_pic = 'no_profile_pic';
      const { school, schoolId, sport, states, city, teamPageUrl, questionLink, division,
              validHighSchool, validQuestionaire, validTeamPageUrl, validCity, validState, coachId,
      } = s;

      payload = Object.assign(payload, {
        fullname: this.props.attributes.get('name'),
        college: school,
        coach_id: coachId,
        college_id: schoolId,
        sport,
        state: states,
        city,
        profile_pic,
        division,
        team_page_link: teamPageUrl,
      });
      if (questionLink !== '') {
        payload['question_link'] = questionLink; // eslint-disable-line
      }
      if (validHighSchool && validQuestionaire && validTeamPageUrl && validCity && validState) {
        this.props.saveCoachProfile(payload);
        if (value === 'loader') {
          this.setState({ startLoader: true });
        }
      }
    });
  }


  render() {
    const { usedFor, adminStyles } = this.props;
    const renderWhileRegistration = renderIf(this.props.usedFor === 'register');
    const renderWhileModify = renderIf(this.props.usedFor === 'modify');
    const renderInContactForm = renderIf(this.props.usedFor === 'contact');
    const renderLoader = renderIf(this.state.startLoader);
    const renderLoaderWhileRegistration = renderIf(this.state.startLoader);
    return (
      <div className={usedFor === 'register' ? cn('row', styles.coachRegistrationContainer) : cn('row', adminStyles)}>
        {renderInContactForm(
          <div className={cn('col s12', styles.autoCompleteContact)}>
            <div className={this.state.highSchoolErrorMessage === '' ? styles.autoCompleteContainer : styles.autoCompleteContainerOnError}>
              <Autocomplete
                inputProps={{ name: 'School', id: 'schools-autocomplete', placeholder: 'College' }}
                ref="schools-autocomplete" // eslint-disable-line
                value={this.state.schoolOnContact}
                items={this.state.schoolNames}
                getItemValue={item => item.value}
                onSelect={(school, item) => {
                    // set the menu to only the selected item
                  this.setState({ schoolOnContact: item.value, highSchoolErrorMessage: '' });
                  this.props.getDataForCoach(item);
                }}
                onChange={(event, value) => {
                  if (this.timer) { clearTimeout(this.timer); }
                  this.setState({ ...this.state,
                    schoolOnContact: value,
                    highSchoolErrorMessage: '',
                    city: '',
                    states: '',
                    teamPageUrl: '',
                    questionLink: '',
                    divisions: '' });

                  if (value && value.length >= 3) {
                    this.timer = setTimeout(() => {
                      this.props.searchSchools(value);
                    }, 100);
                  }
                  this.props.writeCollegeName(value);
                }}
                renderItem={(item, isHighlighted) => (
                  <div
                    style={{ background: isHighlighted ? 'lightgray' : 'white' }}
                    key={item.key}
                    id={item.key}
                  >{item.value}</div>
                      )}
              />
              <Error message={this.state.highSchoolErrorMessage} />
            </div>
          </div>,
          )}
        {renderWhileRegistration(
          <div className={cn('col s12', styles.wrapper)}>
            {renderLoaderWhileRegistration(
              <FullScreenLoader />,
              )}
            <div className={cn('col s12', styles.header)}>
              <span>
                Almost there! <br /> Fill the below details
              </span>
            </div>
            <div className={cn('col s12', styles.inputsContainer)}>
              <div className={cn('col s12 m6', styles.autoComplete)}>
                <span>COLLEGE NAME</span>
                <div className={this.state.highSchoolErrorMessage === '' ? styles.autoCompleteContainer : styles.autoCompleteContainerOnError}>
                  <Autocomplete
                    inputProps={{ name: 'School', id: 'schools-autocomplete' }}
                    ref="schools-autocomplete" // eslint-disable-line
                    value={this.state.school}
                    items={this.state.schoolNames}
                    getItemValue={item => item.value}
                    onSelect={(school, item) => {
                        // set the menu to only the selected item
                      this.setState({ school: item.value, highSchoolErrorMessage: '' });
                      this.setState({ schoolId: item.key,
                        city: item.city,
                        states: item.state,
                        teamPageUrl: item.teamPageUrl,
                        questionLink: item.questionLink,
                        divisions: item.divisions });
                        // or you could reset it to a default list again
                        // this.setState({ unitedStates: getStates() })
                    }}
                    onChange={(event, value) => {
                      if (this.timer) { clearTimeout(this.timer); }
                      this.setState({ ...this.state,
                        school: value,
                        highSchoolErrorMessage: '',
                        city: '',
                        states: '',
                        teamPageUrl: '',
                        questionLink: '',
                        divisions: '' });

                      if (value && value.length >= 3) {
                        this.timer = setTimeout(() => {
                          this.props.searchSchools(value);
                        }, 100);
                      }
                    }}
                    renderItem={(item, isHighlighted) => (
                      <div
                        style={{ background: isHighlighted ? 'lightgray' : 'white' }}
                        key={item.key}
                        id={item.key}
                      >{item.value}</div>
                    )}
                  />
                  <Error message={this.state.highSchoolErrorMessage} />
                </div>
              </div>
              <div className={cn('col s12 m6', styles.autoComplete)}>
                <span>SPORT</span>
                <div className={styles.autoCompleteToolbox}>
                  <AutocompleteToolbox
                    value={this.state.sport}
                    onChange={val => this.handleChange('sport', val)}
                    multiple={false}
                  />
                </div>
              </div>
              <div className={cn('col s12 m6', styles.autoCompleteState)}>
                <span>STATE</span>
                <div className={this.state.stateErrorMessage === '' ? styles.autoCompleteToolbox : styles.autoCompleteToolboxOnError}>
                  <AutocompleteToolbox
                    onChange={val => this.handleChange('states', val)}
                    source={Allstate}
                    onFocus={() => this.removeValue('stateErrorMessage')}
                    onQueryChange={val => this.handleChange('states', val)}
                    value={this.state.states}
                    multiple={false}
                  />
                </div>
                <Error message={this.state.stateErrorMessage} />
              </div>
              <div className={this.state.cityErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanOnError)}>
                <span>CITY</span>
                <Input
                  value={this.state.city}
                  onChange={val => this.handleChange('city', val)}
                  onFocus={() => this.removeValue('cityErrorMessage')}
                />
                <Error message={this.state.cityErrorMessage} />
              </div>
              <div
                className={this.state.teamPageUrlErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpanWithoutTopSpace)
                : cn('col s12 m6', styles.halfWidthWithSpanWithoutTopSpaceOnError)}
              >
                <span>TEAM PAGE URL</span>
                <Input
                  value={this.state.teamPageUrl}
                  onChange={val => this.handleChange('teamPageUrl', val)}
                  onFocus={() => this.removeValue('teamPageUrlErrorMessage')}
                />
                <Error message={this.state.teamPageUrlErrorMessage} />
              </div>
              <div
                className={this.state.questionaireErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpanWithoutTopSpace)
                : cn('col s12 m6', styles.halfWidthWithSpanWithoutTopSpaceOnError)}
              >
                <span>Questionnaire Link</span>
                <Input
                  value={this.state.questionLink}
                  onChange={val => this.handleChange('questionLink', val)}
                  onFocus={() => this.removeValue('questionaireErrorMessage')}
                />
                <Error message={this.state.questionaireErrorMessage} />
              </div>
              <div className={cn('col s12', styles.buttonContainer)}>
                <CustomButton label="NEXT" onClick={() => this.handleOnclick('loader')} />
              </div>
            </div>
          </div>,
          )}
        {renderWhileModify(
          <div className={cn('col s12 m7', styles.modifyContainer)}>
            {renderLoader(
              <FullScreenLoader />,
              )}
            <div className={cn('col s12 m6', styles.autoComplete)}>
              <span>COLLEGE NAME</span>
              <div className={styles.autoCompleteToolbox}>
                <AutocompleteToolbox
                  value={this.state.school}
                  disabled
                  onChange={val => this.handleChange('sport', val)}
                  multiple={false}
                />
              </div>
            </div>
            <div className={cn('col s12 m6', styles.autoComplete)}>
              <span>SPORT</span>
              <div className={styles.autoCompleteToolbox}>
                <AutocompleteToolbox
                  value={this.state.sport}
                  onChange={val => this.handleChange('sport', val)}
                  multiple={false}
                />
              </div>
            </div>
            <div className={cn('col s12 m6', styles.autoCompleteState)}>
              <span>STATE</span>
              <div className={this.state.stateErrorMessage === '' ? styles.autoCompleteToolbox : styles.autoCompleteToolboxOnError}>
                <AutocompleteToolbox
                  onChange={val => this.handleChange('states', val)}
                  source={Allstate}
                  onFocus={() => this.removeValue('stateErrorMessage')}
                  onQueryChange={val => this.handleChange('states', val)}
                  value={this.state.states}
                  multiple={false}
                />
              </div>
              <Error message={this.state.stateErrorMessage} />
            </div>
            <div className={this.state.cityErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanOnError)}>
              <span>CITY</span>
              <Input
                value={this.state.city}
                onChange={val => this.handleChange('city', val)}
                onFocus={() => this.removeValue('cityErrorMessage')}
              />
              <Error message={this.state.cityErrorMessage} />
            </div>
            <div
              className={this.state.teamPageUrlErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpanWithoutTopSpace)
                      : cn('col s12 m6', styles.halfWidthWithSpanWithoutTopSpaceOnError)}
            >
              <span>TEAM PAGE URL</span>
              <Input
                value={this.state.teamPageUrl}
                onChange={val => this.handleChange('teamPageUrl', val)}
                onFocus={() => this.removeValue('teamPageUrlErrorMessage')}
              />
              <Error message={this.state.teamPageUrlErrorMessage} />
            </div>
            <div
              className={this.state.questionaireErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpanWithoutTopSpace)
                      : cn('col s12 m6', styles.halfWidthWithSpanWithoutTopSpaceOnError)}
            >
              <span>Questionnaire Link</span>
              <Input
                value={this.state.questionLink}
                onChange={val => this.handleChange('questionLink', val)}
                onFocus={() => this.removeValue('questionaireErrorMessage')}
              />
              <Error message={this.state.questionaireErrorMessage} />
            </div>
            <div className={cn('col s12', styles.modifyButtonContainer)}>
              <button onClick={() => this.handleOnclick('loader')}>
              UPDATE CHANGES
              </button>
            </div>
          </div>,
          )}
      </div>
    );
  }

}

export default connect(selector,
  { saveCoachProfile,
    getCoachProfile,
    searchSchools,
    getCoachFromDatabase,
    push })(CoachRegistrationModal);



// WEBPACK FOOTER //
// ./src/components/CoachRegistration/CoachRegistration.js